import type { CampaignRankingRow } from '@/features/campaigns/types/campaign'

export interface ResolvedCampaignRankingRows {
  /** Linhas da página atual, exatamente como vieram da API. */
  rows: CampaignRankingRow[]
  /**
   * Linha do usuário logado a ser anexada ao final da lista, ou `null` quando
   * ele já está visível em `rows` (ou não participa da campanha).
   */
  currentUserRow: CampaignRankingRow | null
  /** `true` quando a posição anexada não é contígua à última linha visível. */
  hasGap: boolean
}

/**
 * O ranking de campanha é paginado, então a API devolve a posição do usuário
 * logado num campo irmão (`current_user`) calculado sobre o ranking inteiro —
 * e não dentro de `records`. Este helper mescla os dois, garantindo que o aluno
 * sempre veja a própria colocação sem duplicar a linha quando ele já aparece.
 */
export function resolveCampaignRankingRows(
  records: CampaignRankingRow[],
  currentUser?: CampaignRankingRow | null
): ResolvedCampaignRankingRows {
  if (!currentUser) {
    return { rows: records, currentUserRow: null, hasGap: false }
  }

  const alreadyVisible = records.some(row => row.user_id === currentUser.user_id)

  if (alreadyVisible) {
    return { rows: records, currentUserRow: null, hasGap: false }
  }

  const lastVisible = records[records.length - 1]

  return {
    rows: records,
    currentUserRow: currentUser,
    hasGap: !!lastVisible && currentUser.position > lastVisible.position + 1
  }
}
